import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useState } from "react";

export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void | Promise<void>;
  requireText?: string;
  tone?: "danger" | "default";
  busy?: boolean;
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  onConfirm,
  requireText,
  tone = "default",
  busy,
}: ConfirmDialogProps) {
  const [typed, setTyped] = useState("");
  const disabled = busy || (!!requireText && typed !== requireText);

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        onOpenChange(o);
        if (!o) setTyped("");
      }}
    >
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
        {requireText && (
          <div className="mt-4 space-y-1.5">
            {/* biome-ignore lint/a11y/noLabelWithoutControl: label is visually paired with Input below */}
            <label className="text-xs text-fg-muted">
              Type <span className="mono text-fg">{requireText}</span> to confirm
            </label>
            <Input value={typed} onChange={(e) => setTyped(e.target.value)} autoFocus />
          </div>
        )}
        <div className="mt-5 flex justify-end gap-2">
          <DialogClose asChild>
            <Button variant="default">Cancel</Button>
          </DialogClose>
          <Button
            variant={tone === "danger" ? "danger" : "primary"}
            disabled={disabled}
            onClick={() => onConfirm()}
          >
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
